import React from 'react';
import { getExportExcelUrl } from '../../services/api';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';

const IntegrationsPage = () => {
  return (
    <div data-testid="integrations-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight">Data Export</h1>
        <p className="text-muted-foreground text-sm">Download your data as Excel backup</p>
      </div>

      <div className="max-w-lg">
        <div className="border-2 border-border bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-emerald-600 flex items-center justify-center rounded">
              <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/><path d="M8 15h2v2H8zM8 11h2v2H8zM12 15h2v2h-2zM12 11h2v2h-2z"/></svg>
            </div>
            <div>
              <h2 className="text-lg font-bold">Excel Export</h2>
              <p className="text-xs text-muted-foreground">Download all data as .xlsx file</p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Export all data into one professional Excel sheet — orders, clients, cars, pricing, payments, and shipping in a single row per car.
          </p>
          <div className="flex flex-wrap gap-2 mb-4">
            <Badge variant="secondary">All-in-One Sheet</Badge>
            <Badge variant="secondary">43 Columns</Badge>
          </div>
          <a href={getExportExcelUrl()} target="_blank" rel="noopener noreferrer">
            <Button className="w-full" data-testid="export-excel-btn">Download Excel Backup</Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default IntegrationsPage;
